class ElementUIHelper {
  static DatePickerOptions(params) {
    params = Object.assign({btnToday: false}, params)

    let shortcuts = []

    if (params.btnToday) {
      shortcuts.push({
        text: '今日',
        onClick(picker) {
          picker.$emit('pick', new Date())
        },
      })
    }

    return {
      shortcuts: shortcuts,
    }
  }
}

export default ElementUIHelper

